<template src="./template.html"></template>

<script>
  import { mapState } from 'vuex'
  // import http from '@/api/http'

  export default {
    name: 'PaymentAmazonPay',
    data() {
      return {
        token: '',
        type: '',
      }
    },
    computed: {
      ...mapState('payment', ['activePaymentService']),
    },
    created() {
      this.loadAmazonPay()
    },
    methods: {
      async loadAmazonPay() {
        // console.log(this.$i18n.locale)
        // window.onAmazonPaymentsReady = function () {
        //   new OffAmazonPayments.Widgets.AddressBook({
        //     sellerId: '«= Rails.application.config.amazon[@cart.delivery_address.get_current_country_symbol][:merchant_id] »',
        //     onOrderReferenceCreate: function (orderReference) {
        //       myRef = orderReference.getAmazonOrderReferenceId();
        //       showWallet(myRef);
        //     },
        //     onAddressSelect: function (orderReference) {
        //       myAddr = orderReference;
        //     },
        //     design: {
        //       designMode: 'responsive'
        //     },
        //     onReady: function (orderReference) {},
        //     onError: function (error) {}
        //   }).bind("addressBookWidgetDiv");
        //
        //   var authRequest;
        //   OffAmazonPayments.Button("AmazonPayButton", "«= Rails.application.config.amazon[@cart.delivery_address.get_current_country_symbol][:merchant_id] »", {
        //     type: "Pay",
        //     color: "Gold",
        //     size: "small",
        //     // « if I18n.locale.to_s == 'de' »
        //     language: "de-DE",
        //     // « else »
        //     language: "en-GB",
        //     // « end »
        //     authorization: function () {
        //       loginOptions = {
        //         scope: "profile payments:widget payments:shipping_address payments:billing_address",
        //         popup: "true"
        //       };
        //       authRequest = amazon.Login.authorize(loginOptions, "«= Rails.application.config.hostname »«= I18n.get_url('/checkout/purchase?payment='+PaymentData::PAYMENT_AMAZON.to_s) »");
        //     },
        //     onError: function (error) { // your error handling code }
        //     });
        //   $("#payment-«= pt »").on("click", function () {
        //     $("#AmazonPayButton img").trigger("click");
        //   });
        //
        //   // « if pt == @payment_data.payment_type »
        //   $(".co-sum button.btn-last-step").on("click", function () {
        //     $("#AmazonPayButton img").trigger("click");
        //     return false;
        //   });
        //   // « end »
        // };
      },
    },
  }
</script>
